import React, { useEffect, useState } from "react";
import "./aboutPopupView.scss";
import Modal from "react-bootstrap/Modal";
import { locationOrange, modalClose, employeesBlack } from "../../../../../images";
import useTheme from "../../../../../components/useTheme/useTheme";

const AboutPopupView = (props) => {
  const { theme } = useTheme();
  const [animationClass, setAnimationClass] = useState("opening");
  const { data } = props;
  // When modal opens, add "opening" class
  useEffect(() => {
    if (props.show) {
      setAnimationClass("opening");
    }
  }, [props.show]);

  // When modal is closing, delay actual close to complete animation
  const handleClose = () => {
    setAnimationClass("closing");
    setTimeout(() => {
      props.handleClose();
    }, 100); // Match animation duration
  };
  // Determine which addresses to display
  const displayedAddresses = data?.addresses || []; // Show all on mobile when "See All" is clicked

  const shouldRenderField = (fieldKey) => {
    if (!props?.workflowQuestions || !data?.business_types) return false;
    const question = props.workflowQuestions.find((q) => q.question === fieldKey);
    if (!question) return false;
    const userBusinessTypeIds = data.business_types.map((bt) => bt._id);
    const questionBusinessTypeIds = question.business_types.map((bt) => bt._id);
    return userBusinessTypeIds.some((id) => questionBusinessTypeIds.includes(id));
  };

  const hasOurFocusData =
    (Array.isArray(data?.product_positionings) &&
      data.product_positionings.length > 0) ||
    (shouldRenderField("renovation_work") &&
      (data?.renovation_work === true || data?.renovation_work === "true")) ||
    (shouldRenderField("location_preference") &&
      typeof data?.project_location?.data === "string" &&
      data.project_location.data.trim().length > 0) ||
    (shouldRenderField("minimum_project_size") &&
      Array.isArray(data?.project_sizes?.sizes) &&
      data.project_sizes.sizes.length > 0);

  const hasWhereWeExcelData =
    (shouldRenderField("project_typology") &&
      Array.isArray(data?.project_typology?.data) &&
      data.project_typology.data.length > 0) ||
    (shouldRenderField("service_design_style") &&
      Array.isArray(data?.design_style?.data) &&
      data.design_style.data.length > 0);

  return (
    <>
      <Modal
        {...props}
        centered
        // className="Where_We_excel_popup"
        className={`aboutView_popup ${animationClass} abt_view_popup--common ${theme === "dark" ? "aboutView_popup--mob-dark-mode" : ""}`}
        backdropClassName="custom-backdrop"
        onHide={handleClose}
        // onExit={() => setIsClosing(true)}
      >
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={handleClose}>
            <img
              src={modalClose}
              alt="close-icon"
              className="ctm_img_aboutView_popup"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* 1. About */}
          {data?.bio && (
            <>
              <h2 className="aboutView_popup_heading">About</h2>
              <h6 className="description_aboutView_cmn">{data?.bio}</h6>
            </>
          )}

          {/* 2. Locations */}
          {displayedAddresses?.length > 0 && (
            <div className="row location_popup_row g-4">
              <h2
                className="aboutView_popup_heading"
                style={{
                  marginTop: "1em",
                }}
              >
                Locations
              </h2>
              <div
                className="wrapper_abt_popup_view"
                style={{
                  marginTop: "-1em",
                }}
              >
                {displayedAddresses?.map((address) => (
                  <div className="col-12 location-col-popup">
                    <div className="location_popup_icon_detail_wrapper">
                      <img
                        src={locationOrange}
                        alt="Location"
                        className="location_icon_popup"
                      />
                      <div className="loctaion_wrapper_popup">
                        <div className="location_name_popup">
                          Location :
                        </div>
                        <div className="location_popup">{address.address}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 3. Number of Employees */}
          {data?.team_range?.data && (
            <div className="rating_container" style={{ paddingTop: "1.5em" }}>
              <div className="rating_status">
                <img src={employeesBlack} alt="employees" className="emp_icon" />
                <p className="rating_text">
                  {data.team_range.data} Employees
                </p>
              </div>
            </div>
          )}

          {/* 4. Products/Services — all pills, no heading */}
          {(data?.services?.length > 0 || data?.featured_services?.length > 0) && (
            <ul className="common_ul_popups" style={{ marginTop: "3.5em" }}>
              <li className="common_li_popup common_multi_line_list px-0 mx-0">
                <div className="pills_common_li_popup">
                  {(() => {
                    const featured = data?.featured_services || [];
                    const featuredSet = new Set(featured.map(s => s?.trim?.()?.toLowerCase?.()));
                    const remaining = (data?.services || []).filter(
                      (s) => !featuredSet.has(s?.trim?.()?.toLowerCase?.())
                    );
                    return [...featured, ...remaining];
                  })().map((it, index) => (
                    <div className="pill_span_li" key={index}>{it}</div>
                  ))}
                </div>
              </li>
            </ul>
          )}

          {/* 5. Our Focus */}
          {hasOurFocusData && (
            <>
              <h2
                className="aboutView_popup_heading"
                style={{ paddingTop: "1em" }}
              >
                Our Focus
              </h2>
              <ul className="common_ul_popups common_ul_popups--abt">
                {data?.product_positionings?.length > 0 && (
                  <li className="common_li_popup common_multi_line_list">
                    <div className="wraper_abt_wxcel--popup">
                      Market Positioning :
                    </div>
                    <div className="pills_common_li_popup">
                      {data.product_positionings.map((it, idx) => (
                        <div key={idx} className="pill_span_li">
                          {it}
                        </div>
                      ))}
                    </div>
                  </li>
                )}

                {shouldRenderField("renovation_work") &&
                  (data?.renovation_work === true ||
                  data?.renovation_work === "true") && (
                  <li className="common_li_popup">
                    <div className="wraper_abt_wxcel--popup">
                      Renovation Work :
                    </div>
                    <span className="bold_common_li_popup">Yes</span>
                  </li>
                )}

                {shouldRenderField("location_preference") &&
                  data?.project_location?.data && (
                  <li className="common_li_popup">
                    <div className="wraper_abt_wxcel--popup">
                      Location Preference :
                    </div>
                    <span className="bold_common_li_popup">
                      {data.project_location.data}
                    </span>
                  </li>
                )}

                {shouldRenderField("minimum_project_size") &&
                  data?.project_sizes?.sizes?.length > 0 && (
                  <li className="common_li_popup">
                    <div className="wraper_abt_wxcel--popup">
                      Min. Project Size :
                    </div>
                    <span className="bold_common_li_popup">
                      {data.project_sizes.sizes
                        .map((size) => `${size} ${data?.project_sizes?.unit}`)
                        .join(", ")}
                    </span>
                  </li>
                )}
              </ul>
            </>
          )}

          {/* 6. Where We Excel */}
          {hasWhereWeExcelData && (
            <>
              <h2
                className="aboutView_popup_heading"
                style={{ paddingTop: "1em" }}
              >
                Where We Excel
              </h2>
              <ul className="common_ul_popups common_ul_popups--abt">
                {shouldRenderField("project_typology") &&
                  data?.project_typology?.data?.length > 0 && (
                  <li className="common_li_popup common_multi_line_list">
                    <div className="wraper_abt_wxcel--popup">
                      Project Typology :
                    </div>
                    <div className="pills_common_li_popup">
                      {data.project_typology.data.map((it, idx) => (
                        <div key={idx} className="pill_span_li">
                          {it}
                        </div>
                      ))}
                    </div>
                  </li>
                )}

                {shouldRenderField("service_design_style") &&
                  data?.design_style?.data?.length > 0 && (
                  <li className="common_li_popup common_multi_line_list extra_mb">
                    <div className="wraper_abt_wxcel--popup">
                      Design Style :
                    </div>
                    <div className="pills_common_li_popup">
                      {data.design_style.data.map((it, idx) => (
                        <div key={idx} className="pill_span_li">
                          {it}
                        </div>
                      ))}
                    </div>
                  </li>
                )}
              </ul>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AboutPopupView;
